<template>
  <div class="grid content-start gap-4">
    <template v-for="(rating, index) in list" :key="rating.id">
      <app-divider v-if="index > 0" />
      <course-rating-item :data-cy-rating-id="rating.id" :rating="rating" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { CourseRatingItemView } from "~~/model/course.model";

defineProps<{
  list: CourseRatingItemView[];
}>();
</script>
